import { AlbumMediaInterface } from '../types/AlbumMediaInterface';
import { BrandMediaItem } from '../types/BrandMediaInterface';
import { BlobWrapper } from '../types/MediaInterface';

export type BrandMediaListItem = BlobWrapper | AlbumMediaInterface;

export const toListItems = (items: BrandMediaItem[]): AlbumMediaInterface[] =>
  items.map((item) => ({ mediaID: item.id, mediaURL: item.url, type: item.mediaType }));

const isNew = (item: BrandMediaListItem): item is BlobWrapper => 'file' in item;

export const newFiles = (items: BrandMediaListItem[]): Blob[] => items.filter(isNew).map((item) => item.file);

export const listOrder = (items: BrandMediaListItem[]): string[] => {
  let fileCount = 0;
  return items.map((item) => (isNew(item) ? `filename-${fileCount++}` : String(item.mediaID)));
};

export const removedIDs = (saved: BrandMediaItem[], items: BrandMediaListItem[]): number[] =>
  saved.filter((item) => !items.some((current) => !isNew(current) && current.mediaID === item.id)).map((item) => item.id);

export const singleChange = (
  saved: BrandMediaItem | null,
  current: Blob | string | null
): { upload?: Blob; deleteID?: number } => {
  if (current instanceof Blob) return { upload: current };
  if (!current && saved) return { deleteID: saved.id };
  return {};
};
